"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var addDays_1 = __importDefault(require("../addDays"));
/**
 * Calculates the next review date of a card.
 *
 * @param {string} rating         The rating of the latest attempt.
 * @param {string} previousRating The rating of the previous attempt.
 */
function calculateNextReviewDate(rating, previousRating) {
    // Response was correct
    if (rating === 'correct') {
        // Previous response was not correct
        // Study again in 3 days
        if (previousRating !== 'correct') {
            return addDays_1.default(new Date(), 3);
        }
        // Previous answer was also correct
        // Study again in a week
        return addDays_1.default(new Date(), 7);
    }
    // If the response is not correct the card
    // must be studied again tomorrow
    return addDays_1.default(new Date(), 1);
}
exports.default = calculateNextReviewDate;
//# sourceMappingURL=calculateNextReviewDate.js.map